export default [
  "device.geolocation.get",
  "device.geolocation.start",
  "device.geolocation.stop",
  "device.geolocation.status",
  "device.base.getUUID",
  "device.base.getInterface",
  "device.launcher.checkInstalledApps",
  "device.launcher.launchApp",
  "biz.util.open",
  "biz.contact.choose",
  "biz.contact.chooseMobileContacts",
  "biz.user.get",
  "biz.util.uploadImage",
  "biz.ding.create",
  "biz.ding.post",
  "biz.telephone.call",
  "biz.telephone.showCallMenu",
  "biz.telephone.checkBizCall",
  "biz.telephone.quickCallList",
  "biz.contact.createGroup",
  "biz.map.locate",
  "biz.map.search",
  "biz.map.view",
  "biz.util.uploadImageFromCamera",
  "biz.customContact.multipleChoose",
  "biz.customContact.choose",
  "biz.contact.complexPicker",
  "biz.contact.complexChoose",
  "biz.contact.departmentsPicker",
  "biz.contact.setRule",
  "biz.contact.externalComplexPicker",
  "biz.contact.externalEditForm",
  "biz.chat.pickConversation",
  "biz.intent.fetchData",
  "biz.chat.chooseConversationByCorpId",
  "biz.chat.openSingleChat",
  "biz.chat.toConversation",
  "biz.cspace.saveFile",
  "biz.cspace.preview",
  "biz.cspace.chooseSpaceDir",
  "biz.util.uploadAttachment",
  "biz.clipboardData.setData",
  "biz.chat.locationChatMessage",
  "device.audio.startRecord",
  "device.audio.stopRecord",
  "device.audio.onRecordEnd",
  "device.audio.download",
  "device.audio.play",
  "device.audio.pause",
  "device.audio.resume",
  "device.audio.stop",
  "device.audio.onPlayEnd",
  "device.audio.translateVoice",
  "biz.alipay.pay",
  "device.nfc.nfcWrite",
  "biz.util.encrypt",
  "biz.util.decrypt",
  "runtime.permission.requestOperateAuthCode",
  "biz.util.scanCard"
]


// WEBPACK FOOTER //
// ./src/common/DingTalk/jsApiList.ts